<template>
  <div v-if="emergencyContact.attributes.full_name">
    <h4
      class="font-bold mb-0"
      v-text="`${emergencyContact.attributes.full_name} (${emergencyContact.attributes.relationship})`"
    />
    <p
      class="mt-px"
      v-text="emergencyContact.attributes.phone_number"
    />
  </div>
</template>

<script type="text/babel">
export default {
  name: 'EmergencyContact',
  props: {
    emergencyContact: {
      type: Object,
      required: true,
    },
  },
}
</script>
